import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import { TFunction } from 'i18next';

export function GetBulkActionActiveButtonText(t: TFunction<string, undefined>, type: ApplierOption | string): string {
  const translateText = (text: string, translationKey: string) => {
    const defaultKey = `BULK_ACTION_BUTTON_TEXT_${translationKey}`;
    return t(defaultKey, { defaultValue: text });
  };

  // Need a list of actions based on the selected TODO Like the SummaryGenerator and FilterApplier
  // SmartSendBulkActionOptions
  switch (type) {
    case 'RecipientContactDetails:Add':
      return translateText('Add', 'ADD_DETAILS');

    case 'Service:Add':
      return translateText('Choose', 'ADD_SERVICE');

    case 'Dimensions:Add':
      return translateText('Add', 'ADD_DIMENSIONS');

    case 'TariffCodes:Add':
      return translateText('Add', 'ADD_TARIFF_CODE');

    default:
      return translateText('Fix', 'BULK_ACTION_ACTIVE_BUTTON_TEXT_DEFAULT');
  }
}
